/** @format */

export const getAnimationValue = (
    isAnimating: boolean,
    animationName: string
) => {
    return isAnimating ? animationName : '';
};
